<div #target class="panel" [class.sliding]="isSliding">
	<div #box class="content" [class.hide-content]="hideContent">
		<ng-content></ng-content>
		@if (isSliding) {
			<mat-icon (click)="toggleSliding()" class="pin">push_pin</mat-icon>
		} @else {
			<mat-icon (click)="toggleSliding()" class="pin">open_in_new</mat-icon>
		}
	</div>
	<div class="tab" (click)="togglePanel()">
		<mat-icon [class.rotated]="isOpen">arrow_forward_ios</mat-icon>
	</div>
</div>
